/* eslint-disable @typescript-eslint/camelcase */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Moment from "moment";
import _ from "lodash";
import { makeStyles, Grid } from "@material-ui/core";
import { Typography, Select, Page } from "@packages/ui";
import DownloadButtonGrid from "src/layouts/DashboardLayout/DownloadButtonGrid";
import { useCurrentRental } from "src/hooks/rentalHooks";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 15,
  },
}));

const RentalAgreement = () => {
  const classes = useStyles();
  const app = useSelector((state) => ({ ...state.app }));
  const rentals = useSelector((state) => ({ ...state.app.rentals }));
  const currentRental = useCurrentRental();
  const [rentalAgreement, setRentalAgreement] = useState(
    _.find(rentals, { rental_agreement_number: app.currentRental })
  );
  const pickUpDate = currentRental?.pickup ? currentRental.pickup.dateTime : "No Date Data";
  const fileName = rentalAgreement.signed_rental_agreement
    ? "signed_rental_agreement"
    : "rental_agreement";
  const raNumber = rentalAgreement.rental_agreement_number;
  const signedRentals = rentalAgreement.signed_rental_agreements;

  function handleSelectClick(e) {
    setRentalAgreement(_.find(rentals, { rental_agreement_number: e.target.value }));
  }

  return (
    <Page className={classes.root} title="Rental Agreement - My Journey Portal">
      <div>
        <Typography variant={"h1"} style={{ marginBottom: 30 }}>
          Rental Agreement
        </Typography>
        {currentRental.rental_agreement ? (
          <Grid container>
            <Typography style={{ marginBottom: 30 }}>
              Your rental agreement is available. Select from one of the options below.
            </Typography>
            <Grid container spacing={1}>
              <Grid item>
                <Select
                  title={`${rentalAgreement?.rental_agreement_number} - ${Moment(
                    pickUpDate,
                    "YYYY-MM-DD hh:mm"
                  ).format("DD/MM/YYYY")}`}
                  value={rentalAgreement?.rental_agreement_number}
                  onChange={(e) => handleSelectClick(e)}
                  options={Object.keys(rentals).map((key) =>
                    rentals[key]?.rental_agreement_number
                      ? {
                          value: rentals[key]?.rental_agreement_number,
                          title: rentals[key]?.pickup
                            ? `${rentals[key].rental_agreement_number} - ${Moment(
                                rentals[key].pickup.dateTime,
                                "YYYY-MM-DD hh:mm"
                              ).format("DD/MM/YYYY")}`
                            : `${rentals[key].rental_agreement_number} - No Pickup Data`,
                        }
                      : {
                          value: "0",
                          title: `${rentals[key].rental_agreement_number} - No Rental Agreement`,
                        }
                  )}
                ></Select>
              </Grid>
              <DownloadButtonGrid
                raNumber={raNumber}
                fileName={fileName}
                fileLabel="Rental Agreement"
                originalFlag={signedRentals.length > 1}
              />
            </Grid>
          </Grid>
        ) : (
          <div>
            <Typography style={{ marginBottom: 30 }}>
              Your rental agreement is not currently available. Please check back later.
            </Typography>
          </div>
        )}
      </div>
    </Page>
  );
};

export default RentalAgreement;
